import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapValue'
})
export class MapValuePipe implements PipeTransform {
  transform(obj: any, key: string, withoutComma?: boolean): any {
    return key?.length ? (withoutComma
      ? this.objToDotNotation(obj, key)
      : this.objToDotNotation(obj, key)?.toLocaleString()) : obj;
  }

  objToDotNotation(obj: Record<string, any>, path?: string): any {
    const keys = path?.split('.');
    return keys?.reduce(
      (prev: Record<string, any>, current) =>
        prev ? prev[current] : undefined,
      obj
    );
  }
}
